import { render } from "./ContactLink.vue?vue&type=template&id=5c7f2763&ts=true"
import script from "./ContactLink.vue?vue&type=script&lang=ts"
export * from "./ContactLink.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__